/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Webfusions: DO NOT REMOVE!!! Processing side menu and showing body if its loaded or not available
document.addEventListener("DOMContentLoaded", function () {
  const groupedSections = Array.from(document.querySelectorAll('[data-layout-group="custom-layout"]'));
  const menuSection = document.querySelector('.grid-container-custom-layout .mobile-menu__nav-list');

  if (!menuSection || groupedSections.length === 0) {
    document.body.removeAttribute('data-custom-layout-processing');
    console.log("no menu needed")
    document.querySelector(".grid-container-custom-layout").style.display = "none";
    return;
  }

  const parent = groupedSections[0].parentNode;

  const gridContainer = document.createElement('div');
  gridContainer.classList.add('grid-container-custom-layout');
  gridContainer.style.opacity = 0;
  gridContainer.style.transition = 'opacity 0.5s ease-in-out';

  gridContainer.appendChild(menuSection);

  const anchor = document.createElement('div');
  anchor.setAttribute('data-custom-layout-anchor', '');
  gridContainer.appendChild(anchor);

  parent.insertBefore(gridContainer, groupedSections[0]);

  groupedSections.forEach(section => {
    if (section !== menuSection) {
      anchor.appendChild(section);
    }
  });

  requestAnimationFrame(() => {
    gridContainer.style.opacity = 1;
  });

  document.body.removeAttribute('data-custom-layout-processing');
});







class WFAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcements = this.querySelectorAll(".wf-announcement-item");
    this.nextButton = this.querySelector(".wf-announcement-next");
    this.prevButton = this.querySelector(".wf-announcement-prev");
    this.currentIndex = 0;
    this.delay = this.getAttribute("data-delay");
    this.autoRotate = this.getAttribute("data-auto-rotate");
    console.log(this.delay, this.autoRotate);
    this.interval = null;
  }

  connectedCallback() {
    this.updateAnnouncementDisplay();
    this.setupEventListeners();
    if (this.autoRotate === "true") {
      this.startAutoRotate();
    }
  }

  updateAnnouncementDisplay() {
    this.announcements.forEach((item, idx) => {
      item.classList.remove("active");
      if (idx === this.currentIndex) {
        item.classList.add("active");
      }
    });
  }

  nextAnnouncement() {
    this.announcements[this.currentIndex].style.transform = "translateY(100%)";
    this.currentIndex = (this.currentIndex + 1) % this.announcements.length;
    this.announcements[this.currentIndex].style.transform = "translateY(0)";
    this.updateAnnouncementDisplay();
  }

  prevAnnouncement() {
    this.announcements[this.currentIndex].style.transform = "translateY(-100%)";
    this.currentIndex =
      (this.currentIndex - 1 + this.announcements.length) %
      this.announcements.length;
    this.announcements[this.currentIndex].style.transform = "translateY(0)";
    this.updateAnnouncementDisplay();
  }

  resetInterval() {
    if (this.autoRotate === "true") {
      clearInterval(this.interval);
      this.startAutoRotate();
    }
  }

  startAutoRotate() {
    this.interval = setInterval(() => this.nextAnnouncement(), this.delay);
  }

  stopAutoRotate() {
    clearInterval(this.interval);
  }

  setupEventListeners() {
    this.nextButton.addEventListener("click", () => {
      this.nextAnnouncement();
      this.resetInterval();
    });

    this.prevButton.addEventListener("click", () => {
      this.prevAnnouncement();
      this.resetInterval();
    });
  }

  disconnectedCallback() {
    this.stopAutoRotate();
    this.nextButton.removeEventListener("click", this.nextAnnouncement);
    this.prevButton.removeEventListener("click", this.prevAnnouncement);
  }
}

customElements.define("wf-announcement-bar", WFAnnouncementBar);